/* unplugin-vue-components disabled */import { render } from "./ServiceContract.vue?vue&type=template&id=39674018&scoped=true"
const script = {}

import "./ServiceContract.vue?vue&type=style&index=0&id=39674018&scoped=true&lang=css"

import exportComponent from "/Users/hongboyuan/projects/yszn-code/qipaoWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39674018"]])

export default __exports__